import React, { useEffect } from 'react';
import styles from 'assets/css/CourseComponent.module.css';
import tutorSessionsHelpers from 'Components/Card/helper/tutorSessionsHelpers';
import ScheduleCoursePartials from 'Components/Card/Partials/Partials.ScheduleCourse';
import useAttention from 'context/AttentionContext';
import EventPartials from 'Components/Card/Partials/Partials.Event';
import CardLink from 'Components/Card/CardLink';
import { IconAngleRight }  from '@ace/react-icons';
import buttonStyles from 'assets/css/Button.module.css';
import { getUTCDateFromServerDate } from 'utils/dateUtils';
import CoursePartials from 'Components/Card/Partials/Partials.Course';

/*
[Display States]:
1) not scheduled
2) scheduled
3) [possibly?] audit
4) completed
*/

/*
[Required Props]
Shared
- HeaderText
- SubHeaderText
- HasCourse --> scheduled : not scheduled
- HasUpcomingClass

State: Not Scheduled
- "Schedule Now Display"
- VoucherExpirationDate
- Schedule Now Button

State: Scheduled
- EventDateTime
- EventEnd
- EventOrganizerDisplay
- Event Button (open course, launch class)

State: Completed
- "Completed Date Display"
- Open Course Btn
*/

function TutorSessionsComponent(props) {
    //context(s)
    const { clearAttentionState, setAttentionWarning } = useAttention();

    //local var(s)
    const { tutorSessions: sessions, HasCourse: hasCourse } = props;
    const { 
        showVoucher, 
        showEvent, 
        showSchedule, 
        showComponent,
    } = tutorSessionsHelpers.getShowProperties({ ...sessions, hasCourse });
    
    //effect(s)
    useEffect(() => {
        if (showVoucher) {
            setAttentionWarning();
        } else {
            clearAttentionState();
        }
    }, [showVoucher, setAttentionWarning, clearAttentionState]);

    //render
    if (showComponent) {
        return (
            <div className={styles.contentWrap}>
                <h4 className={styles.courseHeader}>{sessions.HeaderTitle}</h4>
                {showVoucher && <ScheduleCoursePartials.VoucherContent voucherExpirationDate={getUTCDateFromServerDate(sessions.VoucherExpirationDate)} />}
                {showEvent && <TutorSessionEventDisplay {...sessions} />}
                {<CoursePartials.BodyCopy bodyStateCopy={sessions.BodyStateCopy} />}
                {showSchedule && <CardLink
                    linkText={"Schedule your session"}
                    linkIcon={<IconAngleRight />}
                    linkUrl={sessions.ScheduleSessionUrl}
                    target="_blank"
                    className={buttonStyles.stroke} />}
            </div>
        )
    }
    return false;
}

const TutorSessionEventDisplay = (sessions) => {
    if (!sessions.UpcomingSession)
        return false;

    const startDate = getUTCDateFromServerDate(sessions.UpcomingSession?.EventJoinTime);
    const endDate = getUTCDateFromServerDate(sessions.UpcomingSession?.EventEnd);

    const eventDisplayProps = {
        startDate,
        endDate,
        eventTitle: sessions.UpcomingSession?.EventDisplayTitle
    };

    const eventLaunchDisplayProps = {
        startDate,
        endDate,
        beforeEventText: "Scheduled",
        afterEventText: "Join Now",
        duringEventText: "Session Finished"
    };

    return (
        <EventPartials.EventDisplay {...eventDisplayProps}>
            <EventPartials.EventOrganizer eventOrganizerDisplay={sessions.UpcomingSession?.EventOrganizerDisplay} />
            <EventPartials.EventLaunchBtn href={sessions.UpcomingSession?.EventJoinUrl} >
                <EventPartials.EventLaunchBtnContent {...eventLaunchDisplayProps} />
            </EventPartials.EventLaunchBtn>
        </EventPartials.EventDisplay>
    );
}

export default TutorSessionsComponent;